import React, { useEffect, useState } from "react";
import { getAllExamPagination } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { createCollegeCourseExam } from "../../Services/CollegeService";

const AddCollegeCourseExam = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: null,
        college_courses_id: null,
        exam_id: null,
        min_marks: null,
        max_marks: null,
    });
    const [loader, setLoader] = useState(false);
    const [exams, setExams] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCollegeCourseExam(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getExamCall = async () => {
        let { ok, data } = await getAllExamPagination({});
        if (ok) {
            setExams(data?.records);
        }
    };

    useEffect(() => {
        getExamCall();
        if (data?.data) {
            const { id, college_courses_id, exam_id, min_marks, max_marks } = data?.data;
            setReqData({ id, college_courses_id, exam_id, min_marks, max_marks })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Exam" : "Edit Exam"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Exams</label>
                                            <select required value={reqData?.exam_id} onChange={(e) => handleChange("exam_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Select</option>
                                                {exams?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label>Minimum Marks</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Minimum Marks"
                                                    required
                                                    value={reqData?.min_marks}
                                                    onChange={(e) => handleChange("min_marks", e?.target?.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label>Maximum Marks</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Maximum Marks"
                                                    required
                                                    value={reqData?.max_marks}
                                                    onChange={(e) => handleChange("max_marks", e?.target?.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCollegeCourseExam;